export default "__VITE_ASSET__27bdc134__"